const VideoArea = () => {
    return (
        <>
            <div className="desilo-video-area style-2 overflow-hidden">
                <div className="container custom-container">
                    <div className="row">
                        <div className="col-12">
                            <video
                                muted
                                autoPlay
                                loop
                                src="https://videos.pexels.com/video-files/3192305/3192305-uhd_2560_1440_25fps.mp4"
                                className="desilo-video"
                                id="desilo-video-2"
                            />
                            <button className="play-btn">Play</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoArea;
